import { render, staticRenderFns } from "./SecretList.vue?vue&type=template&id=4e20eb3b&scoped=true&"
import script from "./SecretList.vue?vue&type=script&lang=js&"
export * from "./SecretList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e20eb3b",
  null
  
)

export default component.exports